import React from 'react';
import { Navigate } from 'react-router-dom';
import { LoginForm } from '@/features/auth/components/LoginForm';
import { TwoFactorForm } from '@/features/auth/components/TwoFactorForm';
import { useAuthStore } from '@/features/auth/stores/authStore';

export const LoginPage: React.FC = () => {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);
  const pendingTwoFactor = useAuthStore((state) => state.pendingTwoFactor);

  // 認証済みの場合はダッシュボードへリダイレクト
  if (isAuthenticated) {
    return <Navigate to="/dashboard" replace />;
  }

  // 2FA入力画面を表示
  if (pendingTwoFactor) {
    return <TwoFactorForm />;
  }

  // 通常ログインフォーム
  return <LoginForm />;
};